export enum HowPayable {
  PAID_DIRECT_TO_BROKER = 'Paid direct to broker',
}

export enum WhenPayable {
  ON_OFFER = 'On offer',
  ON_APPLICAION = 'On application',
  ON_COMPLETION = 'On completion',
}

export interface IIntermediaryFeesDetails {
  id: string;
  description: string;
  amount: string;
  whenPayable: WhenPayable | null;
  howPayable: HowPayable | null;
  refundableAmount: string;
}

export interface IIntermediaryFeesForm {
  hasIntermediaryFees: string | null;
  fees: IIntermediaryFeesDetails[];
}

export const INDUSTRY_OPTIONS = [
  'Administrative and support services',
  'Airline',
  'Charities',
  'Construction',
  'Drivers/Chauffeurs',
  'Education',
  'Ferry Companies',
  'Financial Services',
  'Hospitality – restaurants & bars',
  'Human health and social work',
  'Information and communication',
  'Internet / E-commerce',
  'Leisure',
  'Manufacturing',
  'Other',
  'Passenger transport',
  'Professional, scientific and technical',
  'Real estate activities',
  'high street retail non food',
  'Road Haulage',
  'Tourism',
  'Water supply, sewage, waste etc',
  'Wholesale and retail trade',
];
